import React, { useContext, useEffect, useRef } from "react";
import { useParams, Redirect } from "react-router-dom";
import { Grid } from "@material-ui/core";
import HotelInfo from "../../components/HotelInfo/HotelInfo";
import BookingCard from "../../components/BookingCard/BookingCard";
import { GeneralContext } from "../../contexts/GeneralContext";

const CheckInMain = () => {
  const { cid } = useParams();
  const { CIDData, doLogout, LngLink, Loading } = useContext(GeneralContext);
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    // Validar que el CID de la URL coincida con el CID autenticado
    if (!Loading && CIDData && CIDData.IDInbox && !hasLoggedOut.current) {
      if (cid !== String(CIDData.IDInbox)) {
        // El CID de la URL no coincide con la reserva autenticada
        // Desloguear y redirigir al login
        hasLoggedOut.current = true;
        doLogout();
      }
    }
  }, [cid, CIDData, Loading, doLogout]);

  // Si estamos cargando o no hay CIDData, mostrar el contenido normalmente
  // El efecto se encargará del logout si es necesario
  if (!Loading && CIDData && CIDData.IDInbox && cid !== String(CIDData.IDInbox)) {
    // Redirigir mientras se procesa el logout
    return <Redirect to={LngLink + "/app/login"} />;
  }

  return (
    <Grid container direction="column">
      <Grid item style={{ width: "100%" }}>
        <HotelInfo />
      </Grid>
      <Grid item>
        <BookingCard />
      </Grid>
    </Grid>
  );
};

export default CheckInMain;
